'use strict';

function Tooltip({ delay = 150 }) {
    const [text,setText] = React.useState("");
    const tooltipRef = React.useRef(null);
    const tooltipTimeout = React.useRef(null);
    const [target, setTarget] = React.useState(null);
    const targetCheckIntervalRef = React.useRef(null);
    
    function positionTooltip($el, $tooltip) {
        const offset = $el.offset();
        const elWidth = $el.outerWidth();
        const ttHeight = $tooltip.outerHeight();

        $tooltip.css({
            top: offset.top - ttHeight - 8,
            left: offset.left + elWidth / 2,
            transform: 'translateX(-50%)',
            zIndex: 1000000
        });
    }
    
    const handleMouseEnter = function () {
        const $el = $(this);
        const text = $el.data('tooltip');
        if (!text) return;

        setTarget(this);
        setText(text);
        
        tooltipTimeout.current = setTimeout(() => {
            if (!tooltipRef.current) 
                return;

            const $tooltip = $(tooltipRef.current);
            $tooltip.css({
                position: 'absolute',
                visibility: 'hidden',
                opacity: 0,
            });

            positionTooltip($el, $tooltip);

            $tooltip
                .css({ visibility: 'visible' })
                .animate({ opacity: 1 }, 150);

        }, delay);
    }

    const handleMouseMove = function ( ) {
        if (!tooltipRef.current)
            return;

        const $tooltip = $(tooltipRef.current);
        if ($tooltip) {
            positionTooltip($(this), $tooltip);
        }
    }
    
    const handleMouseLeave = function () {
        clearTimeout(tooltipTimeout.current);
        if (!tooltipRef.current)
            return;

        const $tooltip = $(tooltipRef.current);

        if ($tooltip) {
            $tooltip.stop().animate({ opacity: 0, visibility: 'hidden' }, 150);
            setTarget(null);
        }
    }
    
    React.useEffect(() => {
        $(document).on('mouseenter', '[data-tooltip]', handleMouseEnter);
        $(document).on('mouseleave', '[data-tooltip]', handleMouseLeave);
        $(document).on('mousemove', '[data-tooltip]', handleMouseMove);
        
        return () => {
            $(document).off('mouseenter', '[data-tooltip]', handleMouseEnter);
            $(document).off('mouseleave', '[data-tooltip]', handleMouseLeave);
            $(document).off('mousemove', '[data-tooltip]', handleMouseMove);
        }
    }, []);
    
    React.useEffect(() => {
        if (!target) {
            clearInterval(targetCheckIntervalRef.current);
            return;
        }
        
        targetCheckIntervalRef.current = setInterval(() => {
            if (!target || !target.checkVisibility()) {
                setTarget(null);
                const $tooltip = $(tooltipRef.current);
                $tooltip.stop().animate({ opacity: 0, visibility: 'hidden' }, 150);
                clearInterval(targetCheckIntervalRef.current);
            }
        }, delay);
        
        return () => {
            clearInterval(targetCheckIntervalRef.current);
            clearTimeout(tooltipTimeout.current);
            setTarget(null);
        }
    }, [ target ]);

    return ReactDOM.createPortal(<TooltipItem ref={tooltipRef} text={text} />, document.body);
}

const TooltipItem = React.forwardRef(({text}, ref) => {
    return <div ref={ref} className="el-tooltip__text" style={{position: 'absolute', top: 0, left: 0, opacity: 0, visibility: 'hidden'}}>{text}</div>
})

export default Tooltip;